import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    sendAuditComment (data) {
        return httpService.post(
            ApiEndpoints.get(data.params.endpoint, {
                familyEditionId: data.params.id,
                sheetType: data.params.sheetType
            }),
            data.data
        );
    },
    sendToAreaAudit (id) {
        return httpService.put(ApiEndpoints.get('send_to_area_audit', { familyEditionId: id }));
    },
    sendToAreaCorrection (id) {
        return httpService.put(ApiEndpoints.get('send_to_area_correction', { familyEditionId: id }));
    },
    sendToNationalAudit (id) {
        return httpService.put(ApiEndpoints.get('send_to_national_audit', { familyEditionId: id }));
    },
    publishSheets (id) {
        return httpService.put(ApiEndpoints.get('sheet_publish', { familyId: id }));
    },
    sendToNationalCorrection (id) {
        return httpService.put(ApiEndpoints.get('send_to_national_correction', { familyEditionId: id }));
    },
    sendToNationalCorrectionVolunteer (id) {
        return httpService.put(
            ApiEndpoints.get('send_to_national_correction_volunteer', { familyEditionId: id })
        );
    },
    sendGiftAuditComment (data) {
        return httpService.post(
            ApiEndpoints.get(data.params.endpoint, {
                familyEditionId: data.params.id,
                sheetType: data.params.sheetType
            }),
            data.data
        );
    },
    sendGiftToAreaAudit (data) {
        return httpService.put(
            ApiEndpoints.get('send_gift_giving_report_to_area_audit', { familyEditionId: data.id }),
            data.data
        );
    },
    sendGiftToAreaCorrection (data) {
        return httpService.put(
            ApiEndpoints.get('send_gift_giving_report_to_area_correction', { familyEditionId: data.id }),
            data.data
        );
    },
    sendGiftToNationalAudit (data) {
        return httpService.put(
            ApiEndpoints.get('send_gift_giving_report_to_national_audit', { familyEditionId: data.id }),
            data.data
        );
    },
    sendGiftToNationalCorrection (data) {
        return httpService.put(
            ApiEndpoints.get('send_gift_giving_report_to_national_correction', {
                familyEditionId: data.id
            }),
            data.data
        );
    },
    sendGiftToNationalCorrectionVolunteer (data) {
        return httpService.put(
            ApiEndpoints.get('send_gift_giving_report_to_national_correction_volunteer', {
                familyEditionId: data.id
            }),
            data.data
        );
    },
    sendGiftToGiftGiver (data) {
        return httpService.post(
            ApiEndpoints.get('send_gift_giving_report', { familyEditionId: data.id }),
            data.data
        );
    }
};
